var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47779 7H5.49999C7.43012 7 9 5.42994 9 3.49963C9 1.57003 7.43012 0 5.49999 0C3.5699 0 2.00002 1.57003 2.00002 3.4982C1.99357 5.42206 3.55271 6.99284 5.47779 7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50037 9C2.57009 9 0 10.6641 0 12.5602C0 15 4.14044 15 5.50037 15C6.8603 15 11 15 11 12.5443C11 10.6561 8.42991 9 5.50037 9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackUserIcon);
export default __webpack_public_path__ + "static/media/black_user_icon.14a5b7e32ae634cfb5df6a209cad0a36.svg";
export { ForwardRef as ReactComponent };